import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '../store';

// Async thunk for fetching users
export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async (options?: { forceRefresh?: boolean }, { rejectWithValue, getState }) => {
    try {
      console.log('Fetching users...', options?.forceRefresh ? '(forced refresh)' : '');

      // Look for either admin or employee token in cookies
      const cookies = document.cookie.split('; ');
      let token = cookies.find(row => row.startsWith('pms_admin_='))?.split('=')[1];

      // If no admin token found, check for employee token
      if (!token) {
        token = cookies.find(row => row.startsWith('pms_employee_='))?.split('=')[1];
      }

      if (!token) {
        console.error('No authentication token found in cookies');
        return rejectWithValue('Authentication token is missing');
      }

      console.log('Token found, making API request...');

      // Make the API request with the token in the headers
      const response = await axios.get('/api/v1/list/users', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log('API response received:', response.data);

      if (response.data.success) {
        // Log the data that will be returned to the reducer
        console.log('Data to be stored in Redux:', response.data.data);
        return response.data.data;
      } else {
        console.error('API returned failure:', response.data);
        return rejectWithValue(response.data.message || 'Failed to fetch users');
      }
    } catch (error: any) {
      console.error('Error fetching users:', error);
      return rejectWithValue(
        error.response?.data?.message || error.message || 'An error occurred while fetching users'
      );
    }
  }
);
